import { Theme } from "@mui/material/styles";

export const getTooltipComponents = (_sunoTheme: Theme) => ({
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        fontSize: "14px"
      }
    }
  }
});
